module.exports = __webpack_public_path__ + "static/media/bg-pontos.851c2ca6.svg";